<template>
  <div>
    <div :style="{ paddingTop: !isShowEdit ? '12px' : '' }">
      <div class="title">Trusted Traveler ID</div>
    </div>
    <div class="ant-table ant-table-scroll-position-left ant-table-default table-box">
      <div class="ant-table-content">
        <div class="ant-table-body">
          <table>
            <thead class="ant-table-thead">
              <tr>
                <th class="ant-table-row-cell-break-word" v-if="!isMainShow">
                  <a-checkbox 
                    :disabled="!this.dataList || this.dataList.length == 0"
                    :indeterminate="indeterminate" 
                    :checked="checkAll" 
                    @change="onCheckAllChange" 
                  />
                </th>
                <th class="ant-table-row-cell-break-word">ID types</th>
                <th class="ant-table-row-cell-break-word">Numbers</th>
                <th class="ant-table-row-cell-break-word">Remark</th>
                <th class="ant-table-row-cell-break-word" v-if="!isShowEdit"></th>
              </tr>
            </thead>
            <tbody class="ant-table-tbody" v-if="!isEditTour">
              <template v-for="(item, index) in dataList">
                <tr class="ant-table-row" :key="'ffp-' + index">
                  <td>
                    <a-select
                      style="width: 100%;"
                      v-model="item.planId"
                      :showArrow="true"
                      showSearch
                      optionFilterProp="children"
                      placeholder="Airlines"
                      :dropdownMatchSelectWidth="false"
                    >
                      <a-select-option v-for="(air, index) in airlineList" :key="air.id + index" :value="air.id">{{ air.asName }}</a-select-option>
                    </a-select>
                  </td>
                  <td>
                    <a-input v-model="item.planNum" />
                  </td>
                  <td>
                    <a-input v-model="item.planRemark" />
                  </td>
                  <td>
                    <a @click="handleAdd" v-if="index == (dataList.length - 1)">
                      <a-icon type="plus"/>
                    </a>
                    <a-divider type="vertical" v-if="(index == (dataList.length - 1) && dataList.length !== 1)" />
                    <a-popconfirm
                      v-if="dataList.length !== 1"
                      title="Are you sure?"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="handleDelete(index)"
                    >
                      <a><a-icon type="delete" style="color:#eb2f96;" /></a>
                    </a-popconfirm>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody class="ant-table-tbody" v-if="isEditTour">
              <template v-if="dataList && dataList.length > 0">
                <template v-for="(item, index) in dataList">
                  <tr class="ant-table-row" :key="'ffp-' + index">
                    <td v-if="!isMainShow">
                      <a-checkbox 
                        :checked="item.checked" 
                        @change="e => onCheckChange(e, index)" 
                      />
                    </td>
                    <td>
                      <div :title="(airlineList.find(e => e.id === item.planId) || {}).asName || ''" class="text-overflow">
                        {{ (airlineList.find(e => e.id === item.planId) || {}).asName || '' }}
                      </div>
                    </td>
                    <td>
                      <div :title="item.planNum" class="text-overflow">
                        {{ item.planNum }}
                      </div>
                    </td>
                    <td>
                      <div :title="item.planRemark" class="text-overflow">
                        {{ item.planRemark }}
                      </div>
                    </td>
                    <td style="width: 130px;" v-if="!isShowEdit">
                      <a-button type="primary" @click="isModalShow = true" v-if="index === (dataList.length-1)"><a-icon type="plus"/> Add New</a-button>
                    </td>
                  </tr>
                </template>
              </template>
              <tr v-else class="ant-table-row">
                <td colspan="5" style="text-align: center;" v-if="!isShowEdit">
                  <a-button type="primary" @click="isModalShow = true"><a-icon type="plus"/> Add New</a-button>
                </td>
                <td colspan="5" v-else>
                  <a-empty :image="simpleImage" description="No Data" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <a-modal
      title="Add New Trusted Traveler ID"
      :destroyOnClose="true"
      :visible="isModalShow"
      :maskClosable="false"
      @cancel="() => { this.isModalShow = false }"
    >
      <a-form-model v-for="(form, pindex) in editeditForms" :key="pindex" :model="form">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="ID types">
              <a-select
                v-model="form.planId"
                :showArrow="true"
                showSearch
                optionFilterProp="children"
                placeholder="Airlines"
                :dropdownMatchSelectWidth="false"
              >
                <a-select-option v-for="(air, index) in airlineList" :key="air.id + index" :value="air.id">{{ air.asName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="Numbers">
              <a-input v-model="form.planNum" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="Remark">
              <a-input v-model="form.planRemark" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <template slot="footer">
        <a-button type="primary" :loading="saving" @click="handleSave">
          Save
        </a-button>
        <a-button @click="() => { this.isModalShow = false }">
          Close
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import CustomerApi from '@/api/api-cdb-custome-v2'

export default {
  name: 'CdbCustomerAirlinesFrequentFlyer',
  components: {
    Empty
  },
  props: {
    ffpList: {
      type: Array,
      default: () => []
    },
    airlineList: {
      type: Array,
      default: () => []
    },
    isEditTour: {
      type: Boolean,
      default: true
    },
    globalCode: {
      type: String,
      default: ''
    },
    isShowEdit: {
      type: Boolean,
      default: false
    },
    isMainShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      saving: false,
      dataList: [],
      editeditForms: [
        { 
          planId: null,
          planNum: null,
          planRemark: null
        }
      ],
      isModalShow: false,
      checkAll: false,
      indeterminate: false,
      selectedRow: []
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      const dataList = this.copyDataByJSON(this.ffpList) || []
      this.dataList = dataList.filter(e => e.planId || e.planNum || e.planRemark)
      if (!this.isEditTour && (!this.dataList || this.dataList.length == 0)) {
        this.handleAdd()
      }
      this.dataList.forEach(item => {
        item.checked = false
      })
    },
    handleAdd () { 
      this.dataList.push({
        planId: null,
        planNum: null,
        planRemark: null
      })
    },
    handleDelete (index) { 
      this.dataList.splice(index, 1)
    },
    handleSave () { 
      this.saving = true
      const editeditForms = this.editeditForms[0]
      CustomerApi.saveSingleFFP(this.globalCode, { 
          planId: editeditForms.planId,
          planNum: editeditForms.planNum,
          planRemark: editeditForms.planRemark
        }).then(res => {
        if (!this.mixinProcessHasBizErrorNotification(res)) {
            this.mixinProcessSuccessNotification('Save success !')
            this.isModalShow = false
            this.saving = false
            this.$emit('update')
          }
      }).catch(() => {
        this.saving = false
      })
    },
    onCheckAllChange (e) { 
      const checked = e.target.checked
      this.dataList.forEach(item => {
        item.checked = checked
      })
      this.checkAll = checked
      this.indeterminate = false

      if (checked) {
      this.selectedRow = this.dataList.filter(item => item.checked)
    } else {
      this.selectedRow = []
    }
    },
    onCheckChange (e, index) {
      const checked = e.target.checked
      this.dataList[index].checked = checked
      const checkedCount = this.dataList.filter(item => item.checked).length
      this.checkAll = checkedCount === this.dataList.length
      this.indeterminate = checkedCount > 0 && checkedCount < this.dataList.length
      this.selectedRow = this.dataList.filter(item => item.checked)
      this.$forceUpdate()
    }
  },
  watch: {
    ffpList: {
      handler (newVal) {
        this.dataList = this.copyDataByJSON(newVal)
      },
      immediate: true
    }
  }
}
</script>
<style lang="less" scoped>
.table-box {
  ::v-deep .ant-input {
    width: 100%;
  }
}
.text-overflow {
  max-width: 280px; 
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .ant-form-item {
  margin-bottom: 6px;
}
</style>
